module.exports = __webpack_public_path__ + "img/show_layer.29ebcf84.svg";